{
	"productImage": "Foto do produto",
	"select": "Selecione uma foto",
	"setTagInput": "procure pelo produto usando palavras chave",
	"notInformed": "Nome não informado",
	"searchMoreOptions": "Procurar mais opções do banco de dados",
	"selectFrom": "Selecionar do ",
	"computer": "computador"
}
